/** Путь вкладки без query (для сравнения одной и той же вкладки). */
export const tabPathname = (url) => {
  if (typeof url !== "string" || !url) return "";
  const q = url.indexOf("?");
  return q >= 0 ? url.slice(0, q) : url;
};
